import IconButton from 'components/Buttons/IconButton.index';
import ItemButton from 'components/Buttons/ItemButton/ItemButton.index';
import PlayerAudioButton from 'components/Buttons/PlayerAudioButton.index';
import SubscriberInfo from 'components/Topbar/SubscriberInfo/SubscriberInfo.index';
import SubscribeNowBannerButton from 'components/Buttons/SubscribeNowBannerButton.index';
import VersaoAcervoButton from 'components/Buttons/VersaoAcervoButton.index';
import { useIcon } from 'hooks/useIcon';
import { AssetsContext } from 'providers/Assets';
import { DrawersContext } from 'providers/DrawersProvider';

import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import SearchInput from 'components/SearchInput/SearchInput.index';
import { ServerSidePropsContext } from 'providers/ServerSideProps';
import axios from 'axios';
import { useKeycloak } from '@react-keycloak/ssr'
import { SessionDataContext } from 'providers/Session';
import { removeSessionDataCookie } from 'providers/Session/utils';
import { KeycloakInstance } from 'keycloak-js';

const buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black',
    },
    hideInMobile: false,
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7',
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0',
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px',
      },
    },
    value: 'DIGITAL',
    hideInMobile: false,
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black',
    },
    cssContainer: {
      mr: '$4',
    },
    hideInMobile: false,
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020',
    },
    hideInMobile: false,
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black',
    },
    hideInMobile: false,
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6',
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px',
      },
    },
    value: 'ÁUDIO',
    hideInMobile: false,
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite',
    },
    hideInMobile: false,
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined,
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0',
      },
    },
    value: 'ENTRAR',
    hideInMobile: false,
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite',
    },
    hideInMobile: false,
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black',
    },
    hideInMobile: false,
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800',
    },
    hideInMobile: false,
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    hideInMobile: false,
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content',
    },
    hideInMobile: false,
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#DAE5FB',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content',
      },
    },
    hideInMobile: false,
  },
};

export const TopbarMobileSlotLeft = () => {
  const drawersContext = useContext(DrawersContext);
  return (
    <>
      <IconButton
        icon={useIcon('IcHamburguerMobile')}
        onClick={() =>
          drawersContext.handleSideMenuLeft({
            open: !drawersContext.sideMenuLeftState.open,
          })
        }
      />
    </>
  );
};
export const TopbarDesktopSlotLeft = () => {
  const router = useRouter();
  const drawersContext = useContext(DrawersContext);
  const urlParams = new URLSearchParams(window.location.search);
  const termParam = urlParams.get('term') || '';
  const [showSearch, setShowSearch] = useState(false);
  const [term, setTerm] = useState(termParam);

  const handleSearch = () => {
    const url = window.location.origin + `/pesquisa?term=${term}`
    window.location.assign(url)
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTerm(event.target.value);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };
  const handleBlur = () => {
    if (!term) {
      setShowSearch(false);
    }
  };
  const searchIcon = useIcon('IcBuscar');

  return (
    <>
      <IconButton
        icon={useIcon('IcHamburger')}
        id='menu-hamburguer'
        onClick={() =>
          drawersContext.handleSideMenuLeft({
            open: !drawersContext.sideMenuLeftState.open,
          })
        }
      />
      {!showSearch ? (
        <IconButton
          icon={searchIcon}
          id='busca-menu'
          onClick={() => setShowSearch(!showSearch)}
        />
      ) : (
        <SearchInput
          id='ojc-search-input-topbar'
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onSearch={handleSearch}
          onBlur={handleBlur}
          css={{
            container: { mt: '14px', mb: '$4', maxWidth: '320px' },
            input: { ml: '$2', width: 'calc(100% - $6)' },
            icon: { button: { mr: '$0' } },
          }}
        />
      )}
    </>
  );
};
export const TopbarDesktopSlotRight = () => {
  const assetsContext = useContext(AssetsContext);
  const serverSideContext = useContext(ServerSidePropsContext);
  const router = useRouter();
  const sessionData = useContext(SessionDataContext);
  const banners = assetsContext?.assets?.banners;
  const bannerAssine = banners.find((i) => i.name === 'BannerAssineAgora');
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const isPaywall =
    serverSideContext?.site?.pageConfig?.featureRadioSelectPaywall;

  async function keycloakSessionLogOut(id) {
    return await axios.delete(`/paywall/delete-sessao/${id}`);
  }

  const handleLogin = async () => {
    try {
      console.log(document.cookie)
      await keycloak?.login({
        redirectUri: `${window.location.href}`,
      });
    } catch (error) {
      console.error('Error during login:', error);
    }
  };

  return (
    <>
      <SubscribeNowBannerButton
        alt='Assine'
        colorSchema='secondary'
        href={process.env.NEXT_PUBLIC_URL_LOJA || ''}
        imgSrc={bannerAssine.url}
        imgHeight=''
        imgWidth=''
      />
      {isPaywall !== 'DESATIVADO' && (
        <SubscriberInfo
          amountLeft={keycloak?.tokenParsed?.exp}
          onAnonymousClick={handleLogin}
          onLogout={() => {
            if (sessionData?.id == undefined) {
              keycloak?.logout();
            } else {
              keycloakSessionLogOut(sessionData?.id).then(async (res) => {
                if (res.status == 200) {
                  keycloak?.logout();
                  removeSessionDataCookie();
                } else {
                  console.log('Erro ao fazer login');
                }
              });
            }
          }}
          onGuestClick={() => {
            const url = window.location.origin + '/perfil'
            window.location.assign(url)
          }}
          onSubscriberClick={() => {
            const url = window.location.origin + '/perfil'
            window.location.assign(url)
          }}
          type={sessionData ? 'ASSINANTE' : 'anonymous'}
        />
      )}
    </>
  );
};
export const TopbarTopSlotLeft = () => {
  return (
    <>
      <a
        href='https://www.gjccorp.com.br/'
        title='GJC'
        target='_blank'
        rel='noreferrer'
      >
        <IconButton icon={useIcon('IcOjc')} />
      </a>
    </>
  );
};

export const TopbarTopSlotRight = () => {
  return (
    <>
      <ItemButton
        href='https://classi.com.br'
        value='Classi'
        {...buttons.topbarTopItemsRight}
      />
      <ItemButton
        href='https://daqui.opopular.com.br/'
        value='Jornal Daqui'
        {...buttons.topbarTopItemsRight}
      />
      <ItemButton
        href='https://www.cbntocantins.com.br/'
        value='CBN Tocantins'
        {...buttons.topbarTopItemsRight}
      />
      <ItemButton
        href='https://opopular.com.br/'
        value='Jornal O Popular'
        {...buttons.topbarTopItemsRight}
      />
    </>
  );
};
export const TopbarExtraSlotRight = () => {
  return (
    <>
      {/* <VersaoAcervoButton
      onClick={() =>
        window.open('https://www.jornaldotocantins.com.br/digital/')
      }
      icon={useIcon('IcVersaoDigitalCinzaClaro')}
      id='digital-menu'
    /> */}
    </>
  );
};
